import { filter, flow, get, map } from 'lodash/fp';

const mapStats = flow(
  filter('display'),
  map(item => ({
    id: item.id,
    name: item.name,
    quantity: item.value,
    score: item.score,
    unitValue: item.score_per_value
  }))
);

function decodeTeamGameStats(data) {
  return {
    played: true,
    score: get('team.score', data),
    statistics: mapStats(get('team.stats', data))
  };
}

export default decodeTeamGameStats;
